import { StepType, type Experience } from '../../../../../types/CoreShoppingExperience';
import convertProductToItem from './convertProductToItem';

const convertFallbackToViewItemListEvent = (experience: Experience) => {
  const items = experience.purchasableTrips
    .flatMap((trip) => trip.steps)
    .filter((step) => step.stepType === StepType.SEGMENT)
    .flatMap((step) => step.products)
    .flatMap((product) =>
      product.fallbackVariants?.map((variant) => {
        return { product, variant };
      }),
    );

  // Extra check in case fallbackVariants was undefined/empty as it is an optional value
  const convertedItems = items.flatMap((item, itemIndex) =>
    item ? convertProductToItem(item.variant, item.product, itemIndex) : [],
  );

  return convertedItems.length
    ? {
        items: convertedItems,
      }
    : null;
};

export default convertFallbackToViewItemListEvent;
